import { memo, useState } from 'react';

import { Collapse, Text } from '@/lib/v2/components';

export interface AccordionRowProps {
  label?: string;
  children?: React.ReactNode;
  isStartOpen?: boolean;
}

const AccordionRow = ({ label, children, isStartOpen = false }: AccordionRowProps) => {
  const [isOpened, setIsOpened] = useState<boolean>(isStartOpen);

  const handleOpen = () => {
    setIsOpened((prevOpened) => !prevOpened);
  };

  return (
    <div className="relative h-auto w-full">
      <div className="w-full border-b">
        <div className="relative w-full px-6 py-4">
          <button className="flex w-full items-center justify-between" onClick={handleOpen}>
            <Text fontWeight="medium">{label}</Text>
            <span
              className={`relative h-full w-[10px] ${
                !isOpened ? 'rotate-180' : 'rotate-0'
              } transition-all`}
            >
              <span className="relative top-0.5 inline-block size-[10px] rotate-45 border-l-2 border-t-2 border-emblue-subheadings bg-transparent"></span>
            </span>
          </button>
        </div>
      </div>
      <Collapse isOpened={isOpened}>
        <div className="relative w-full border-b">
          <div className="w-full px-6 py-4">{children}</div>
        </div>
      </Collapse>
    </div>
  );
};

export default memo(AccordionRow);
